module.exports = __webpack_public_path__ + "static/media/liderazgo.d2ecf844.jpg";